import { Alert, Input, PrimaryButton } from '@artprov/design-system'
import { useVerificarEmail } from './verificar-email.hook'
import { useEffect } from 'react'
import { Show } from '../../../common/components/Show'
import { Status } from '../verificar-email/lib/lib'

export function VerificarEmailSection() {
  const { onSubmit, onChange, onReset, value, disabled, status, error } = useVerificarEmail()

  const handleKeydown = (event) => {
    if (event.key === 'Enter' && !disabled) {
      onSubmit()
    }
  }

  useEffect(() => {
    window.addEventListener('keydown', handleKeydown)
    return () => {
      window.removeEventListener('keydown', handleKeydown)
    }
  }, [disabled, onSubmit]) // eslint-disable-line react-hooks/exhaustive-deps

  const hints = status === Status.INVALID ? [{ variant: 'error', text: error?.message }] : []

  return (
    <section className="flex flex-col gap-2 bg-tertiary-98 p-6 rounded w-full">
      <Show when={status === Status.INTERNAL_ERROR}>
        <Alert
          variant="error"
          containerStyle="max-w-none "
          title={error?.title}
          description={error?.message}
          interactive={false}
          autoDismiss={false}
          iconStyle="text-error-10"
          icon="cancel"
        />
      </Show>
      <Show when={status === Status.ALREADY_EXISTS}>
        <Alert
          variant="error"
          containerStyle="max-w-none "
          title={error?.title}
          description={error?.message}
          interactive={false}
          autoDismiss={false}
          iconStyle="text-error-10"
          icon="cancel"
        />
      </Show>

      <p>Para hacer la verificación, necesitamos que confirmes tu correo electrónico.</p>

      <div className="flex flex-col gap-8 bg-tertiary-100 p-6 mt-2 border border-tertiary-80 rounded-lg">
        <Input
          type="email"
          label="Correo electrónico"
          status={status === Status.INVALID ? 'error' : 'default'}
          isRequired
          placeholder="Ingresa tu correo electrónico"
          hints={hints}
          className="w-full"
          leftIcon="mail"
          onChange={onChange}
          rightFunction={onReset}
          value={value}
        />

        <PrimaryButton type="submit" className="w-full" disabled={disabled} onClick={onSubmit}>
          Confirmar
        </PrimaryButton>
      </div>
    </section>
  )
}
